import { ThemeToggle } from './components/ThemeToggle'
import { DesignSystemProvider, useDesignSystem } from './context/provider'
import { ThemeConst } from './themes/theme.const'

export const DesignSystem = {
  use: useDesignSystem,
  Provider: DesignSystemProvider,
  ThemeToggle,
  ThemeConst,
}
